import React from 'react'

const Montserrat = ({children}) => {
  return (
    <div className='font-montserrat'>{children}</div>
  )
}

export default Montserrat